module.exports = __webpack_public_path__ + "img/P17a_Tims-Poppies-7.140b9144.jpg";